import {Stack, Typography} from "@mui/material";
import {appStyles} from "../../../../AppStyles.ts";

function UXResourceEnrichmentPanel() {
    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            <Stack direction="row" padding={1} justifyContent="center">
                <Typography sx={appStyles.panelSectionTitle}>Enrichment</Typography>
            </Stack>
        </Stack>
    );
}

export default UXResourceEnrichmentPanel;
